function DropdownUpIcon({
    height = 4, 
    width = 7, 
    className = '',
    color = '#0F172A'
}) {

    return (
        <svg 
            width={width} 
            height={height} 
            viewBox="0 0 7 4" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path 
                d="M3.08333 0.166585L0.1225 3.12888C0.0816668 3.16985 0.0510417 3.21415 0.030625 3.26179C0.0102084 3.30943 1.80613e-08 3.35756 1.59364e-08 3.40617C1.16867e-08 3.50339 0.0343753 3.58846 0.103125 3.66138C0.171875 3.73429 0.2625 3.77075 0.375 3.77075L6.58333 3.77075C6.69583 3.77075 6.78646 3.73325 6.85521 3.65825C6.92396 3.58325 6.95833 3.49575 6.95833 3.39575C6.95833 3.38186 6.9175 3.29318 6.83583 3.12971L3.875 0.166585C3.81944 0.11103 3.75694 0.069363 3.6875 0.0415854C3.61806 0.0138077 3.54861 -8.1384e-05 3.47917 -8.13871e-05C3.40972 -8.13901e-05 3.34028 0.0138077 3.27083 0.0415853C3.20139 0.069363 3.13889 0.11103 3.08333 0.166585Z"
                fill={color}
            />
        </svg>
    )
}

export default DropdownUpIcon;